import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'

@Component({
  selector: 'app-megamenuview',
  templateUrl: './megamenuview.component.html',
  styleUrl: './megamenuview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MegamenuviewComponent implements OnInit, OnChanges {
  @Input() placeholder: String;
  @Input() name: String;
  @Input() items: Array<object>;
  @Input() activeTab: String;
  @Output() onItemSelect = new EventEmitter();
  @Output() onMenuClick = new EventEmitter();
  @Output() openMyViewsPopUp = new EventEmitter();
  @Input() listStyle: any;
  filteredItems: Array<object>;
  currentActiveTab: String;
  native: any;
  @Input() showMore: boolean = false;
  @Input() fromMegaMenu: boolean = false;

  contextmenu = false;
  contextmenuX = 0;
  contextmenuY = 0;
  itemId = '';

  @ViewChild('contextMenuContainer') contextMenuContainer: ElementRef;

  ngOnInit() {
    this.assignCopy(); //On Server call
    this.currentActiveTab = this.activeTab;
  }

  assignCopy() {
    this.filteredItems = Object.assign([], this.items);
  }
  ngOnChanges(changes: SimpleChanges) {
    if ('items' in changes) {
      this.filteredItems = changes.items.currentValue;
    }
    if ('activeTab' in changes) {
      this.currentActiveTab = changes.activeTab.currentValue;
    }
  }
  filterItem(value: string) {
    if (!value) {
      this.assignCopy();
    }
    this.filteredItems = Object.assign([], this.items).filter(
      (item) => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1
    );
  }
  toggleShowMore() {
    this.showMore = !this.showMore;
  }

  updateItemList(viewname, type, count) {
    if (this.items) {
      if (type === 'add') {
        let index = this.items.findIndex((item: any) => item.name === viewname);
        if (index < 0) {
          this.items.push({ name: viewname, count: count });
        }
      } else if (type === 'remove') {
        this.items = Object.assign([], this.items).filter(
          (item) => item.name !== viewname
        );
      } else {
        console.log('searchList.updateItemList: Unknown type:', type);
      }
      this.assignCopy();
    }
  }

  itemSelected(event: any) {
    this.onItemSelect.emit(event);
    this.contextmenu = false;
  }
  menuSelected(event: any) {
    this.onMenuClick.emit(event);
  }
  addSelected(event: any) {
    this.openMyViewsPopUp.emit(event);
  }

  // onRightClick(event) {
  //   if(!this.fromMegaMenu) {
  //     event.preventDefault();
  //     this.contextmenuX = event.clientX;
  //     this.contextmenuY = event.clientY;
  //     this.itemId = event.currentTarget.id;
  //     this.contextmenu = true;
  //   }
  // }

  disableContextMenu() {
    this.contextmenu = false;
  }

  onContainerClick(event: MouseEvent) {
    if (event.target === this.contextMenuContainer.nativeElement) {
      this.contextmenu = false;
    }
  }

  onContainerRightClick(event: MouseEvent) {
    event.preventDefault();
    this.contextmenu = false;
  }
}
